module.exports = __webpack_public_path__ + "static/img/9.b7f8379.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/13/sp/9.png
// module id = C/hv
// module chunks = 0